module.exports = __webpack_public_path__ + "static/media/btbms-mb-en.bb70a429.jpg";